import React, { useEffect, useState } from "react";
import {
	DataGrid,
	GridRenderCellParams,
	GridColDef,
	esES,
} from "@mui/x-data-grid";
import { Button, Card, Box, Typography, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppSelector } from "../../../hooks/storeHooks";
import { fetchSpots, deleteSpot } from "../../../services/spotService";
import { mdiCircleSlice1 } from "@mdi/js";
import Icon from "@mdi/react";
import NewSpotModal from "./NewSpotModal";

const SpotsView: React.FC = () => {
	const theme = useTheme();
	const { isLoading, spots } = useAppSelector(
		(state: any) => state.spotReducer
	);
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedSpot, setSelectedSpot] = useState<Spot | null>(null);

	useEffect(() => {
		fetchSpots();
	}, []);

	const columns: GridColDef[] = [
		{
			field: "name",
			minWidth: 150,
			flex: 1,
			headerName: "Nombre",
			headerAlign: "center",
			align: "center",
			renderCell: (params: GridRenderCellParams) => (
				<Typography variant="body1">{params.row.name}</Typography>
			),
		},
		{
			field: "edit",
			minWidth: 100,
			flex: 1,
			headerName: "Editar Punto",
			headerAlign: "center",
			align: "center",
			filterable: false,
			disableColumnMenu: true,
			sortable: false,
			renderCell: (params: GridRenderCellParams) => (
				<Button
					variant="contained"
					startIcon={<EditIcon />}
					sx={{
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						"&:hover": { backgroundColor: theme.palette.primary.dark },
					}}
					onClick={() => {
						const spot = spots.find((sp: Spot) => sp._id === params.row._id);
						if (spot) {
							setSelectedSpot(spot);
							setModalOpen(true);
						}
					}}
				>
					Editar
				</Button>
			),
		},
		{
			field: "delete",
			minWidth: 100,
			flex: 1,
			headerName: "Eliminar Punto",
			headerAlign: "center",
			align: "center",
			filterable: false,
			disableColumnMenu: true,
			sortable: false,
			renderCell: (params: GridRenderCellParams) => (
				<Button
					variant="contained"
					startIcon={<DeleteIcon />}
					sx={{
						backgroundColor: theme.palette.error.main,
						color: theme.palette.common.white,
						"&:hover": { backgroundColor: theme.palette.error.dark },
					}}
					onClick={() => deleteSpot(params.row._id)}
				>
					Eliminar
				</Button>
			),
		},
	];

	return (
		<Box sx={{ p: 3, height: "100%", overflow: "auto" }}>
			<Typography variant="h4" sx={{ mb: 3 }}>
				Puntos
			</Typography>
			<Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
				<Button variant="contained" onClick={() => setModalOpen(true)}>
					Agregar
				</Button>
			</Box>
			{isLoading ? (
				<Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
					<Icon spin path={mdiCircleSlice1} className="w-7" />
				</Box>
			) : (
				<Card>
					<DataGrid
						sx={{ p: 2 }}
						autoHeight
						columns={columns}
						rows={spots}
						pageSize={20}
						getRowId={(row) => row._id}
						localeText={esES.components.MuiDataGrid.defaultProps.localeText}
					/>
					<NewSpotModal
						open={modalOpen}
						spot={selectedSpot}
						setSpot={setSelectedSpot}
						onClose={() => setModalOpen(false)}
					/>
				</Card>
			)}
		</Box>
	);
};

export default SpotsView;
